import React from 'react'
import './about.scss'

export default function About() {
  return (
    <div className='about'>
        <h1>About Me</h1>
        <h3>I like building things and I like solving problems - making apps is just an extension of that. 
            My pickleball friends wanted a better way to organize casual play, so I made Dinkupp. 
            I wanted to learn how to improvise on guitar better, so I created a system and then turned that into an app - Noodler. 
            I used to work as a Chemist for a defense contractor, but they wouldn't let me bring any chemicals home to experiment with, so I knew I needed a career change. 
            I'm completely self taught, so right now I'm just looking for the right opportunity to 'get my foot in the door'. Until then, I'll keep coding. 
            
            </h3>
    </div>

  )
}
